var React = require('react');

function RightArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.5 8.50391L19.5607 9.56457L20.6213 8.50391L19.5607 7.44325L18.5 8.50391ZM1.625 7.00391C0.796572 7.00391 0.124998 7.67548 0.124998 8.50391C0.124998 9.33233 0.796572 10.0039 1.625 10.0039L1.625 7.00391ZM12.8107 16.3146L19.5607 9.56457L17.4393 7.44325L10.6893 14.1932L12.8107 16.3146ZM19.5607 7.44325L12.8107 0.693249L10.6893 2.81457L17.4393 9.56457L19.5607 7.44325ZM18.5 7.00391L1.625 7.00391L1.625 10.0039L18.5 10.0039L18.5 7.00391Z","fill":"white"}));
}

RightArrowIcon.defaultProps = {"width":"21","height":"17","viewBox":"0 0 21 17","fill":"none"};

module.exports = RightArrowIcon;

RightArrowIcon.default = RightArrowIcon;
